if (!customElements.get('anatomy-generations')) {
  class AnatomyGenerations extends HTMLElement {
    constructor() {
      super();
      this.handlePrevClick = () => this.scrollByCard(-1);
      this.handleNextClick = () => this.scrollByCard(1);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-gen-track]');
      this.prevButton = this.querySelector('[data-gen-prev]');
      this.nextButton = this.querySelector('[data-gen-next]');

      if (!this.track) {
        return;
      }

      this.prevButton?.addEventListener('click', this.handlePrevClick);
      this.nextButton?.addEventListener('click', this.handleNextClick);
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.handlePrevClick);
      this.nextButton?.removeEventListener('click', this.handleNextClick);
    }

    scrollByCard(direction) {
      if (!this.track) {
        return;
      }

      const card = this.track.querySelector('.hp-gen-card');
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const cardWidth = card ? card.getBoundingClientRect().width : 0;
      const amount = cardWidth > 0 ? cardWidth + gap : 400;
      const prefersReducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: direction * amount,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('anatomy-generations', AnatomyGenerations);
}
